import Level0 from './Level0.vue'
import Level1 from './Level1.vue'
import Level2 from './Level2.vue'
import Level3 from './Level3.vue'
import Level4 from './Level4.vue'

export const levels = [
  [ 'You need two hands', Level0 ],
  [ ', and two ears', Level1 ],
  [ ', and two devices', Level2 ],
  [ 'on two platforms', Level3 ],
  [ ', and yourself and a friend', Level4 ],
]
